import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

function AdminMenuRecommendations() {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchRecommendations = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "siteContent", "menuRecommendations");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setRecommendations(docSnap.data().recommendations || []);
        } else {
          console.log("No menu recommendations document found!");
        }
      } catch (error) {
        console.error("Error fetching menu recommendations:", error);
        setMessage("Error al cargar las recomendaciones.");
      }
      setLoading(false);
    };

    fetchRecommendations();
  }, []);

  useEffect(() => {
    // Cleanup object URLs on unmount
    return () => {
      recommendations.forEach(rec => {
        if (rec.imagePreview) {
          URL.revokeObjectURL(rec.imagePreview);
        }
      });
    };
  }, [recommendations]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const storage = getStorage();
      const updatedRecommendations = await Promise.all(recommendations.map(async (rec) => {
        if (rec.imageFile) {
          const imageRef = ref(storage, `menuRecommendations/${rec.imageFile.name}`);
          await uploadBytes(imageRef, rec.imageFile);
          const imageUrl = await getDownloadURL(imageRef);
          return { ...rec, image: imageUrl, imageFile: null, imagePreview: null }; // Clear the file and preview after upload
        }
        return rec;
      }));

      await setDoc(doc(db, "siteContent", "menuRecommendations"), {
        recommendations: updatedRecommendations,
        updatedAt: new Date(),
      });

      setRecommendations(updatedRecommendations);
      setMessage("Recomendaciones guardadas exitosamente!");
    } catch (error) {
      console.error("Error saving recommendations: ", error);
      setMessage("Error al guardar las recomendaciones.");
    }
    setLoading(false);
  };

  const handleAddRecommendation = () => {
    setRecommendations([...recommendations, { image: '', name: '', description: '', pairing: '' }]);
  };

  const handleRemoveRecommendation = (index) => {
    const newRecommendations = [...recommendations];
    newRecommendations.splice(index, 1);
    setRecommendations(newRecommendations);
  };

  const handleInputChange = (e, index) => {
    const { name, value, files } = e.target;
    const newRecommendations = [...recommendations];
    if (name === 'imageFile' && files[0]) {
      newRecommendations[index]['imageFile'] = files[0];
      // Create a temporary URL for preview
      newRecommendations[index]['imagePreview'] = URL.createObjectURL(files[0]);
    } else {
      newRecommendations[index][name] = value;
    }
    setRecommendations(newRecommendations);
  };

  return (
    <div className="admin-content" style={{ marginBottom: '30px', padding: '20px', border: '1px solid #eee', borderRadius: '8px' }}>
      <h3>Gestionar Recomendaciones del Menú</h3>
      {loading && <p>Cargando recomendaciones...</p>}
      {message && <p className="admin-message" style={{ marginTop: '10px', color: message.includes('Error') ? 'red' : 'green' }}>{message}</p>}
      <form onSubmit={handleSave} className="admin-form">
        {recommendations.map((rec, index) => (
          <div key={index} style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
            <h4>Recomendación {index + 1}</h4>
            <input type="text" name="name" value={rec.name} onChange={(e) => handleInputChange(e, index)} placeholder="Nombre del plato" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', marginBottom: '10px' }} />
            
            <div style={{ marginBottom: '10px' }}>
              <label>Imagen del Plato:</label>
              <input type="file" name="imageFile" onChange={(e) => handleInputChange(e, index)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
              {(rec.imagePreview || rec.image) && (
                <img src={rec.imagePreview || rec.image} alt="Preview" style={{ maxWidth: '200px', marginTop: '10px', borderRadius: '4px' }} />
              )}
            </div>

            <textarea name="description" value={rec.description} onChange={(e) => handleInputChange(e, index)} placeholder="Descripción" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', marginBottom: '10px' }} />
            <input type="text" name="pairing" value={rec.pairing} onChange={(e) => handleInputChange(e, index)} placeholder="Maridaje" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', marginBottom: '10px' }} />
            <button type="button" onClick={() => handleRemoveRecommendation(index)} style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}>Eliminar</button>
          </div>
        ))}
        <button type="button" onClick={handleAddRecommendation} style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' }}>Añadir Recomendación</button>
        <button type="submit" disabled={loading} style={{ padding: '10px 15px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Guardar Recomendaciones</button>
      </form>
    </div>
  );
}

export default AdminMenuRecommendations;